<template>
  <div class="box">
    <el-drawer
      :visible.sync="visible"
      :wrapperClosable="false"
      :show-close="false"
      :append-to-body="true"
      :close-on-press-escape="false"
      custom-class="drawer1"
      :size="size"
    >
      <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
        “
        <span style="color:red">{{title}}</span>
        ” 项目阶段性报告
      </div>
      <el-form
        :model="reportForm"
        :inline="true"
        :rules="rules2"
        ref="reportRef"
        label-position="top"
        :disabled="disabled"
      >
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form-item label="报告名称：" prop="report_name" style="width:100%">
              <el-input
                v-model="reportForm.report_name"
                size="small"
                :controls="false"
                placeholder="阶段性报告名称"
                style="width:85%"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-form-item label="资助总费用：" prop="total_medical_expenses" style="width:100%">
              <el-input-number
                :min="0"
                v-model="reportForm.total_medical_expenses"
                type="number"
                size="small"
                style="width:85%"
                :precision="2"
                :controls="false"
                placeholder="资助总费用,例如：5000.00"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form-item label="报告开始日期：" prop="regdate_start" style="width:100%">
              <el-date-picker
                v-model="reportForm.regdate_start"
                type="date"
                value-format="yyyy-MM-dd"
                size="small"
                style="width:85%"
                placeholder="选择项目开始时间"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="报告结束日期：" prop="regdate_end" style="width:100%">
              <el-date-picker
                @change="getEndTime"
                v-model="reportForm.regdate_end"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:85%"
                size="small"
                placeholder="选择项目结束时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" justify="center" v-if="reportForm.regdate_end">
          <el-col :span="20">
            <el-form-item label="结算情况：" style="width:100%">
              <div
                v-if="reportForm.financial_funds_budget1 && reportForm.financial_funds_budget1.length>0"
              >
                <el-table
                  :data="reportForm.financial_funds_budget1"
                  border
                  style="width: 362px;margin:20px"
                >
                  <el-table-column prop="time" label="日期" align="center" width="180"></el-table-column>
                  <el-table-column prop="amount" label="金额" align="center" width="180"></el-table-column>
                </el-table>
                <!-- <div>
                  捐款总额：
                  <span style="font-weight:600;color:red">{{reportForm.payment_sum}}</span>元
                </div>-->
              </div>
              <div style="color:red" v-else>暂无结算信息~</div>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="10">
            <el-form-item label="回款情况：" style="width: 100%;">
              <div
                v-if="reportForm.financial_funds_budget2 && reportForm.financial_funds_budget2.length>0"
              >
                <el-table
                  :data="reportForm.financial_funds_budget2"
                  border
                  style="width: 100%;margin:20px"
                  v-if="reportForm.financial_funds_budget2 && reportForm.financial_funds_budget2.length>0"
                >
                  <el-table-column prop="time" label="日期" align="center" width="180"></el-table-column>
                  <el-table-column prop="amount" label="金额" align="center" width="180"></el-table-column>
                </el-table>
                <div v-else>
                  回款总额：
                  <span style="font-weight:600;color:red">{{reportForm.return_sum}}</span>元
                </div>
              </div>
              <div style="color:red">暂无回款信息~</div>
            </el-form-item>
          </el-col>-->
        </el-row>

        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form-item label="筛查人数：" style="width: 100%;">
              <el-input
                :min="0"
                v-model.number="reportForm.report_screen_number"
                size="small"
                type="number"
                style="width:85%"
                :controls="false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="阶段性执行报告：" style="width: 100%;">
              <el-upload
                ref="fileUploadRef"
                :action="uploadFileUrl"
                :before-upload="beforeUploadPdf"
                :limit="1"
                :file-list="defFile"
                :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defFile');
                    }"
            :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defFile');
                    }"
                style="width:85%"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
              <i class="el-icon-info">上传格式：pdf，且大小不能超过300M的附件</i>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-form-item label="拨款申请说明：">
              <el-upload
                ref="imgUploadRef"
                :action="uploadImgUrl"
                list-type="picture-card"
                :on-preview="showImg"
                :data="uploadParms"
                name="img"
                :file-list="defImg"
                multiple
                :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defImg');
                    }"
            :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defImg');
                    }"
                :before-upload="beforeUpload"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-form-item label="典型案例：" required>
              <div class="edit_container">
                <ueditor :defaultMsg="defaultMsg" :config="config" ref="casesRef"></ueditor>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="demo-drawer-footer">
        <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-check"
          @click="submitBtn"
          :loading="loading"
          v-if="!disabled"
        >提交</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import ueditor from "@/components/ueditor.vue";
export default {
  components: {
    ueditor
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    size: {
      type: [String, Number],
      default: "85%"
    },
    pid: {
      type: [Number, String],
      default: null
    },
    aid: {
      type: [Number, String],
      default: null
    },
    id: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      uploadImgUrl: null,

      defFile:[],
      defImg:[],

      defaultMsg: "", // 富文本框默认内容  典型案例

      report_info: {}, //项目相关信息

      uploadParms: { file_type: 2 }, //图片上传所需参数
      uploadImgUrl: null,
      uploadFileUrl: "", //上传链接

      financialType1: [], //大类
      financialType2: [], //小类
      config: {
        initialFrameWidth: null,
        initialFrameHeight: 300,
        scaleEnabled: true,
        zIndex: 4000
      },
      //editorOption: {},  //富文本编辑器

      img_url: null,
      img_show: null,
      reportForm: {
        financial_funds_budget1: [], //已拨付金额
        financial_funds_budget2: [], //回款金额
        report_screen_number: null, //筛查人数
        cases: null,
        report_screen_list_file_id: null, //筛查名单
        report_stamp_pic: [] //盖章图片集
      }, //阶段性报告

      // reportList: [],

      rules2: {
        report_name: [
          { required: true, message: "请输入报告名称！", trigger: "blur" }
        ],
        total_medical_expenses: [
          { required: true, message: "请输入资助总费用！", trigger: "blur" }
        ],
        regdate_end: [
          { required: true, message: "请选择报告结束日期！", trigger: "change" }
        ]
      }
    };
  },

  methods: {
    cancelBtn() {
      this.visible = false;
    },

    handlerUpload(fileList, name) {
      this.$set(this, name, []);
      this.$set(this, name, fileList);
    },

    //报告结束时间事件
    getEndTime() {
      if (this.reportForm.regdate_start) {
        let regdate_start = new Date(Date.parse(this.reportForm.regdate_start));
        let regdate_end = new Date(Date.parse(this.reportForm.regdate_end));
        let endDate = new Date(Date.parse(this.report_info.regdate_end));

        if (regdate_end < regdate_start) {
          this.reportForm.regdate_end = "";
          this.$message({
            type: "warning",
            message: "报告结束时间不能小于开始时间！"
          });
        } else if (regdate_end > endDate) {
          this.reportForm.regdate_end = endDate;
          this.$message({
            type: "warning",
            message: "报告结束时间不能大于项目结束时间！"
          });
        } else {
          if (this.reportForm.regdate_end) {
            this.getPaymentInfo(
              this.reportForm.regdate_start,
              this.reportForm.regdate_end
            );
          }
        }
      }
    },

    //获取执行机构捐款信息
    getPaymentInfo(regdate_start, regdate_end) {
      this.$db
        .post(this.$db.config.com_project.info.get_report_info, {
          allocation_starttime: regdate_start,
          allocation_endtime: regdate_end,
          approval_id: this.aid
        })
        .then(res => {
          if (res && res.code == 200) {
            this.reportForm.financial_funds_budget1 = res.data.payment_list;
            this.reportForm.payment_sum = res.data.payment_sum;
            // this.reportForm.financial_funds_budget2 = res.data.return_list;
            // this.reportForm.return_sum = res.data.return_sum;
          }
        });
    },

    showImg(file) {
      //预览图片
      this.img_url = file.url;
      this.img_show = true;
    },

    beforeUpload(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    ///项目内容删除
    delFinancialDrag(index) {
      this.reportForm.financials.splice(index, 1);
    },

    // getStartTime() {
    //   //项目开始时间事件
    //   if (this.reportForm.regdate_end) {
    //     let regdate_start = new Date(Date.parse(this.reportForm.regdate_start));
    //     let regdate_end = new Date(Date.parse(this.reportForm.regdate_end));

    //     if (regdate_end < regdate_start) {
    //       this.reportForm.regdate_start = "";
    //       this.$message({
    //         type: "warning",
    //         message: "项目开始时间不能大于项目结束时间！"
    //       });
    //     } else {
    //       this.getIntervalMonth();
    //     }
    //   }
    // },

    submitBtn() {
      this.$refs["reportRef"].validate(valid => {
        if (valid) {
          
          if (
            this.defFile &&
            this.defFile[0]
          ) {
            let arr = [];
            for (const item of this.defFile) {
              if (item.hasOwnProperty("response")) {
                arr.push(item.response.data.id);
              } else {
                arr.push(item.id);
              }
            }
            this.reportForm.report_screen_list_file_id = arr[0];
          }

          if (
            this.defImg &&
            this.defImg[0]
          ) {
            let arr = [];
            for (const item of this.defImg) {
              if (item.hasOwnProperty("response")) {
                arr.push(item.response.data.id);
              } else {
                arr.push(item.id);
              }
            }
            this.reportForm.report_stamp_pic = arr;
          }

          //典型案例
          let info = this.$refs["casesRef"].getUEContent();
          if (!info) {
            return this.$message.warning("请填写典型案例！");
          } else {
            this.reportForm.cases = info;
          }

          let url;
          if (Number(this.id) > 0) {
            url = this.$db.config.com_project.info.report_edit;
          } else {
            url = this.$db.config.com_project.info.report_add;
          }
          this.loading = true;
          this.$db.post(url, this.reportForm).then(res => {
            this.loading = false;
            if (res && res.code == 200) {
              this.$message.success(res.msg);
              this.cancelBtn();
              this.$emit("success");
            }
          });
        } else {
          return this.$message.warning("请填写完整报告表单信息！");
        }
      });
    },
    beforeUploadPdf(file) {
      let bool = this.$fnc.checkUploadFile(file, ["pdf"]);
      return bool;
    },

    //获取详情
    getInfo() {
      this.$db
        .post(this.$db.config.com_project.info.report_info, { id: this.id })
        .then(res => {
          if (res && res.code == 200) {
            this.reportForm = res.data;
            this.defFile = res.data.report_screen_list_file_id_path;
            this.defImg = res.data.report_stamp_pic_path;
            this.$set(this, "defaultMsg", res.data.cases);
          }
        });
    },

    //根据项目id获取报告相关信息
    getReportInfo() {
      this.$db
        .post(this.$db.config.com_project.info.report_config, { id: this.pid })
        .then(res => {
          this.report_info = res.data;
          if (this.id > 0) {
          } else {
            this.$set(
              this.reportForm,
              "regdate_start",
              res.data.before_report_end
            );
          }
        });
    }
  },
  watch: {
    visible(val) {
      this.$emit("input", val);
    },

    value: {
      handler(val) {
        this.visible = val;
      },
      immediate: true
    }
  },
  created() {
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;

    if (Number(this.id) > 0) {
      this.getInfo();
    }
    if (Number(this.pid) > 0) {
      this.getReportInfo();
      this.reportForm.project_id = this.pid;
    }
  }
};
</script>
<style lang="scss" scoped>
.box /deep/ .drawer1 {
  overflow: auto;
}
.demo-drawer-footer {
  width: 85%;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 4001;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.edit_container {
  line-height: 20px;
  margin-bottom: 90px;
}

.financials /deep/.el-form-item__content {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/info/report.vue